// extracted by mini-css-extract-plugin
module.exports = {"fullNameWidth":"20%","dynamicColWidth":"15%","emailWidth":"13%","genderWidth":"10%","ageWidth":"12%","addressWidth":"30%"};